import React from "react";
import { NavLink } from "react-router-dom";
import ReactPlayer from "react-player";

var bgimg1 =
  "https://www.terreoceane.com/wp-content/uploads/2018/01/salon_Helia-670x417.jpg";

class About3 extends React.Component {
  render() {
    return (
      <>
        <div
          className={`${this.props.bgcolor} organisations our-history section-full mobile-page-padding p-t80 p-b50`}
        >
          {/* <div className="hilite-title text-left p-l50 text-uppercase">
            <strong>Organisation</strong>
          </div> */}
          <div className="container">
            <div className="section-content">
              <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-12">
                  <div data-aos-duration="800"  data-aos="fade-right" className="about-home-3 bg-white">
                    <h3
                      style={{ fontWeight: "800", color: "#357dab" }}
                      className="m-t0"
                    >
                      Conditions d’adhésion
                    </h3>
                    <ul className="m-l50">
                      <li>
                        Acceptation de votre demande d’adhésion par le Conseil
                        d’Administration de l’association ;
                      </li>
                      <li>
                        Respect des clauses du statut et du règlement interne de
                        l’association.
                      </li>
                      <li>Paiement des droits d’adhésion dans les délais ;</li>
                      <li>Respect des délais de paiement des échéances.</li>
                    </ul>
                  </div>
                  <div data-aos-duration="800"  data-aos="fade-right" className="about-home-3 bg-white">
                    <h3
                      style={{ fontWeight: "800", color: "#357dab" }}
                      className="m-t0"
                    >
                      Dossier d’adhésion
                    </h3>
                    <ul className="m-l50">
                      <li>Demande d’adhésion ;</li>
                      <li>Fiche de renseignement dument renseignée ;</li>
                      <li>Engagement légalisé ;</li>
                      <li>Copie CIN ;</li>
                      <li>
                        Attestation de travail ou tout autre document précisant
                        la profession ;
                      </li>
                      <li>
                        Reçu de virement/versement de la première tranche
                        d’adhésion au compte bancaire de l’association.
                      </li>
                    </ul>
                  </div>
                  <div data-aos-duration="800"  data-aos="fade-right" className="about-home-3 bg-white">
                    <h3
                      style={{ fontWeight: "800", color: "#357dab" }}
                      className="m-t0"
                    >
                      Documentations
                    </h3>
                    <ul className="m-l50">
                      <li>
                        <a
                          target="_blank"
                          href={
                            "https://associationlavallee.com/documentation/#"
                          }
                          className="btn-block"
                        >
                          <span
                            style={{ fontSize: "20px" }}
                            className="text-red m-r10"
                          >
                            <i className="fa fa-file-pdf-o" />
                          </span>
                          <strong className="  text-black">Statut ALV</strong>
                        </a>
                      </li>
                      <li>
                        <a
                          target="_blank"
                          href={
                            "https://associationlavallee.com/documentation/#"
                          }
                          className="btn-block"
                        >
                          <span
                            style={{ fontSize: "20px" }}
                            className="text-red m-r10"
                          >
                            <i className="fa fa-file-pdf-o" />
                          </span>
                          <strong className="  text-black">
                            Règlement Intérieur
                          </strong>
                        </a>
                      </li>
                      <li>
                        <a
                          target="_blank"
                          href={
                            "https://associationlavallee.com/wp-content/uploads/2013/09/5-Fiche-de-renseignement.pdf"
                          }
                          className="btn-block"
                        >
                          <span
                            style={{ fontSize: "20px" }}
                            className="text-red m-r10"
                          >
                            <i className="fa fa-file-pdf-o" />
                          </span>
                          <strong className="  text-black">
                            Fiche de renseignement
                          </strong>
                        </a>
                      </li>
                      <li>
                        <a
                          target="_blank"
                          href={
                            "https://associationlavallee.com/wp-content/uploads/2013/09/6-Engagement.pdf"
                          }
                          className="btn-block"
                        >
                          <span
                            style={{ fontSize: "20px" }}
                            className="text-red m-r10"
                          >
                            <i className="fa fa-file-pdf-o" />
                          </span>
                          <strong className="  text-black">Engagement</strong>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div data-aos-duration="800"  data-aos="fade-left" className="col-xl-6 col-lg-6 col-md-12 pic-bg-border">
                  <div
                    className="our-history-pic bg-no-repeat bg-center bg-cover"
                    data-stellar-background-ratio="0.5"
                    style={{ backgroundImage: "url(" + bgimg1 + ")" }}
                  ></div>
                  {/* <div className="video-section-full-v2">
                    <div
                      className="video-section-full bg-no-repeat bg-cover bg-center m-b30"
                      style={{ backgroundImage: "url(" + bgimg1 + ")", height: '100%' }}
                    >
                      <div className="overlay-main" />
                      <div className="video-section-inner">
                        <div className="video-section-content"></div>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default About3;
